module.exports = __webpack_public_path__ + "img/bg_utility.e46a9ef4.png";